import { PriceListRecord, fromJSON } from "common/records/PriceList";
import { RootActions, RootState } from "common/reducers";
import { OrderedMap, Record, List } from "immutable";
import { reducer as idsManagementReducer } from "common/reducers/idsManagement.reducer";
import { IdsManagementActions } from "common/reducers/idsManagement.actions";
import { receive, fetch, loaded } from "common/reducers/Utils";
import { PriceListOverviewRecord, priceListOverviewFromJSON } from "common/records/PriceListOverview";
import {
  FETCH_PRICE_LIST,
  PriceListActions,
  RECEIVE_PRICE_LIST,
  RECEIVE_PRICE_LISTS,
  SET_PRICE_LIST_LOADED,
  RECEIVE_PRICE_LIST_OVERVIEWS,
  RECEIVE_PRICE_LIST_OVERVIEW,
} from "common/reducers/priceList.actions";

export const PriceListStateRecord = Record({
  byId: OrderedMap<number, PriceListRecord>(),
  priceListOverviewsById: OrderedMap<number, PriceListOverviewRecord>(),
});

export const initialState = PriceListStateRecord();

export type PriceListState = typeof initialState;

export const model = "priceLists";

export const reducer = (state: RootState, action: RootActions): RootState => {
  if (state && !state.getIn([model])) {
    state = state.setIn([model], initialState);
  }

  switch (action.type) {
    case FETCH_PRICE_LIST:
      return fetch(state, model, fromJSON({ id: action.payload.priceListId })) as RootState;

    case RECEIVE_PRICE_LIST_OVERVIEW:
      const priceListOverview = priceListOverviewFromJSON(action.payload.priceListOverview);
      state = state.setIn([model, "priceListOverviewsById", priceListOverview.id], priceListOverview);
      if (action.payload.pushToList) {
        state = idsManagementReducer(state, IdsManagementActions.pushId(priceListOverview.id, "priceListOverviews"));
      }
      return state;

    case RECEIVE_PRICE_LIST_OVERVIEWS:
      action.payload.priceListOverviews.forEach((priceListOverview) => {
        state = reducer(state, PriceListActions.receivePriceListOverview(priceListOverview));
      });
      return state;

    case RECEIVE_PRICE_LIST:
      const priceList = fromJSON(action.payload.priceList);
      if (action.payload.pushToList) {
        state = idsManagementReducer(
          state,
          IdsManagementActions.pushId(priceList.id, `${model}.${action.payload.kind}`),
        );
      }
      state = receive(state, model, priceList) as RootState;
      return state;

    case RECEIVE_PRICE_LISTS:
      const priceLists = List(action.payload.priceLists);
      priceLists.forEach((priceList) => {
        state = reducer(state, PriceListActions.receivePriceList(priceList, action.payload.kind));
      });

      return state;

    case SET_PRICE_LIST_LOADED:
      return loaded(state, model, action.payload.priceListId) as RootState;

    default:
      return state;
  }
};
